import Desplegable from "../../desplegable";
import VistaCargo from "../vistas/vista_cargo";

const DesplegableCargos = ({eventKey, showModalMatrix, name, cargos}) => {
   // console.log(`àaaaaaaaaaaaaaaaaaaaaa`+ parseInt(parseInt(eventKey) + 1))
   // console.log(`àaaaaaaaaaaaaaaaaaaaaa`+ eventKey)
    //console.log(showModalMatrix)
    return (
        <Desplegable
            eventKey={eventKey}
            id={eventKey}
            showModal={showModalMatrix[parseInt(eventKey)]}
            Toogle={name}
            Text={
                <VistaCargo
                    cargos={cargos}
                    showModalArray={showModalMatrix[parseInt(eventKey) + 1]}/>
            }
            canEdit={false}
        />
    );
};

export default DesplegableCargos;